/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/GiveStar.css";

import { Rating } from "react-simple-star-rating";

/////////////   Redux  //////////////
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

export default function GiveStarEN(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const detailReport = JSON.parse(sessionStorage.getItem("detailReport2"));

  const [lang, setLanguage] = useState(true);
  const [rating, setRating] = useState(0);

  useEffect(() => {
    setRating(detailReport["case"]["star"]);
  }, []);
  const handleRating = (rate) => {
    setRating(rate);
    // console.log(rate);
  };

  return (
    <div class="container-givestar">
      <div
        className={`container-bg-givestar ${
          detailReport["case"]["star"] != null ? "disable-div" : ""
        }`}
        style={{ gap: "16px" }}>
        <div
          className="div-eng"
          style={{ flexDirection: "column", marginTop: "0.5rem" }}>
          <p className="txt-eng1">Your feedback matters!</p>
          <p className="txt-eng2">
            How well did we solve this problem? (Tap your rating on the screen)
          </p>
        </div>

        <Rating
          onClick={handleRating}
          initialValue={rating}
          disabled="true"
          size={24}
        />
      </div>

      <div>
        <p className="main-txt">
          Thank you for your valuable contribution to making our city more
          livable.
        </p>
      </div>
    </div>
  );
}
